var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"help-icon"},[_c('font-awesome-icon',{attrs:{"id":_vm.id,"icon":"question-circle","size":"1x","color":"#FF9D00"}}),_c('b-tooltip',{attrs:{"target":_vm.id,"triggers":"hover"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }